import initCarousel from '../../components/carousel';

const loadFeaturedRecipes = () => {
	const featuredRecipes = document.querySelector( '.wp-block-rte-atf-featured-content' );

	if ( ! featuredRecipes ) {
		return;
	}

	const carouselContainer = featuredRecipes.querySelector( '.rte-carousel' );
	initCarousel( carouselContainer );
};

window.addEventListener( 'DOMContentLoaded', loadFeaturedRecipes );
window.addEventListener( 'altisBlockContentChanged', loadFeaturedRecipes );

// Enable HMR
if ( module.hot ) {
	module.hot.accept();
}
